const PAYMENT_ARRAY_KEYS = [
  'cash',
  'transfer',
  'credits',
  'installments',
  'refunds',
  'deposit',
];

/**
 * Debug log khi build payload hóa đơn — trace undefined paymentRefId trên cash[0], transfer[0], ...
 * Dùng console.warn để luôn hiện trong DevTools (console.debug bị ẩn khi filter "Info").
 */
export function logBillPaymentDebug(tag, mainModel, phase = 'setBillData') {
  const payments = {};
  const issues = [];

  PAYMENT_ARRAY_KEYS.forEach((key) => {
    const arr = mainModel?.[key];
    const isArray = Array.isArray(arr);
    const first = isArray && arr.length > 0 ? arr[0] : undefined;

    payments[key] = {
      isArray,
      length: isArray ? arr.length : null,
      rawType: isArray ? 'array' : typeof arr,
      firstItem: first,
      paymentRefId: first?.paymentRefId,
      paymentAmount: first?.paymentAmount,
    };

    if (!first) {
      issues.push(
        `${key}[0] missing (length=${isArray ? arr.length : 'not-array'})`,
      );
    }
  });

  const payload = {
    billId: mainModel?.id,
    billNumber: mainModel?.billNumber,
    storeId: mainModel?.storeId,
    billType: mainModel?.billType,
    payments,
    paymentInfo: mainModel?.paymentInfo,
  };

  // warn + log: hiện ở mọi level filter (trừ khi tắt Warnings)
  console.warn(`[BILL_PAYMENT_DEBUG] ${tag} / ${phase}`, payload);
  console.log('[BILL_PAYMENT_DEBUG] payments snapshot', JSON.stringify(payments, null, 2));

  if (issues.length) {
    console.error(
      `[BILL_PAYMENT_DEBUG] ${tag} / ${phase} — paymentRefId sẽ lỗi vì:`,
      issues,
    );
  }
}

/**
 * Đọc paymentRefId an toàn — tránh crash khi mảng payment rỗng.
 */
export function getFirstPaymentRefId(arr) {
  return arr?.[0]?.paymentRefId ?? null;
}

export function getFirstPaymentRow(arr) {
  return arr?.[0] ?? null;
}
